import { Navigate } from 'react-router-dom';
import { useAuth } from '../store/auth';

/** Where a signed-in user lands: super admins on the platform view, everyone
 *  else on their organization's stores (spec 2026-09-02 §A6). */
export function landingPath(role: string | undefined): string {
  return role === 'admin' ? '/platform' : '/stores';
}

export default function Landing() {
  const me = useAuth((s) => s.me);
  return <Navigate to={landingPath(me?.role)} replace />;
}
